const ANNOUNCEMENT_URL =
  'https://res.cloudinary.com/coast-riders/image/upload/v1604266996/enduro-perun/raspis.pdf';

export { ANNOUNCEMENT_URL };
